import { ref, reactive, SetupContext } from '@vue/composition-api'
import { useScrollLoad } from '@/utils/system'

const getGoodsCommonData = (function() {
    let isStarted = false
    const exportModules: {
        [prop: string]: any
    } = {}

    return function() {
        if (isStarted) {
            return exportModules
        }

        isStarted = true
        exportModules.status = ref(
            localStorage.getItem('isShowDownGoods') == null
            ? undefined
            : (
                JSON.parse(localStorage.getItem('isShowDownGoods') as string)
                ? undefined
                : 0
            )
        )
        exportModules.goodsGroup = ref<any[], any[]>([])
        exportModules.currentActiveGroup = reactive({
            level1: 0,
            level2: 0
        })
        exportModules.allGoodsCount = ref(0)
        exportModules.noGroupGoodsCount = ref(0)
        exportModules.hasGroupGoodsCount = ref(0)
        exportModules.allGoodsCount = ref(0)
        exportModules.noGroupGoodsCount = ref(0)
        exportModules.hasGroupGoodsCount = ref(0)
        exportModules.keyword = ref('')
        exportModules.isGroupLoading = ref(false)
        exportModules.isGoodsListLoading = ref(false)
        exportModules.isSearch = ref(false)
        exportModules.isGroupLoading = ref(false)
        exportModules.goodsList = ref<any[], any[]>([])
        exportModules.selectedGoods = ref<number[], number[]>([])
        exportModules.goodsGroup = ref<any[], any[]>([])
        exportModules.currentActiveGroup = reactive({
            level1: 0,
            level2: 0
        })

        const  {
            eventTarget,
            page,
            isHasMore,
            isLoading,
            bindListener,
            initScrollLoad,
            getCurEvent
        } = useScrollLoad()
        exportModules.eventTarget = eventTarget
        exportModules.page = page
        exportModules.isHasMore = isHasMore
        exportModules.isLoading = isLoading
        exportModules.bindListener = bindListener
        exportModules.initScrollLoad = initScrollLoad
        exportModules.getCurEvent = getCurEvent

        return exportModules
    }
})()

export default getGoodsCommonData
